// 导入vant
import vant from 'vant';
// 导入样式文件
import 'vant/lib/index.css';
import Vue from 'vue';
// 全局注册组件
Vue.use(vant);